const applicants = {
  applicantsList: "Applicants List",
  listApplicants: {
    listApplicantsBreadcrumb: "Applicants List",
    applicantsBreadcrumb: "Applicants",
    getKnowTeam: "GET TO KNOW  our team!",
    name: "Name",
    email: "Email",
    fullName: "Applicant full name",
    profileStatus: "Profile Status",
    verified: "Verified",
    unverified: "Not Verified",
    profile_completed: "Full Profile Completed",
    basic_profile_completed: "Basic Profile Completed",
    applicantStatus: "Applicant Status",
    unblocked: "Unblocked",
    block: "Block",
    assigned: "Assigned",
    notAssigned: "Not Assigned",
    nationality: "Nationality",
    studyField: "Fields of Study",
    profileRate: "Rating",
    role: "Role",
    note: "Note",
    tags: "Tags",
    tag: "Tag",
    company: "Company",
    addTag: "Add Tag",
    gender: "Gender",
    notProvided: "Not Provided",
    male: "Male",
    female: "Female",
    prefer_not_to_say: "Not Provided",
    language: "Language",
    speaking: "Speaking Proficiency",
    shift: "Shift",
    age: "Age",
    zone: "Zone",
    ageRange1: "16 - 25",
    ageRange2: "25 - 30",
    ageRange3: "30 - 35",
    ageRange4: "35 - 40",
    height: "Height",
    heightRange1: "140 - 160 CM",
    heightRange2: "160 - 180 CM",
    heightRange3: "180 - 200 CM",
    heightRange4: "200 -300 CM",
    weight: "Weight",
    weightRange1: "40 - 50 KG",
    weightRange2: "50 - 70 KG",
    weightRange3: "70 - 100 KG",
    weightRange4: "100 - 120 KG",
    weightRange5: "120 - 170 KG",
    disability: "Disability",
    diseases: "Diseases",
    searchPlaceHolder: "Search by applicant's name, applicant's id",
    showingRange: "Showing {from}-{to} of {total} applicants",
    emptyState: {
      title: "No Applicants Yet",
      description:
        "There are no applicants in the system yet. Applicants will appear here once they register.",
    },
    filteredEmptyState: {
      title: "No Results Found",
      description:
        "No applicants match your search or filter criteria. Try adjusting your search or filters.",
    },
    noDataDescription: "Sorry, No Applicants found.",
    noDisease: "No disease",
    noDisability: "No disability",
    cityOfResidence: "City",
    applicantPromotePrivileges:
      "Are you sure you want to grant admin privileges to this user?",
    applicantDemotePrivileges:
      "Are you sure you want to remove admin privileges from this user?",
    addShiftType: "Add shift type",
    noShiftFound: "No Shift Found!",
  },
  applicantDetails: {
    applicantDetailsBreadcrumb: "Applicant's Details",
    editProfilePageTitle: "Edit profile",
    applicantDetails: "Applicant's Details",
    totalHours: "Total working hours",
    requests: "Requests",
    events: "Events",
    rated: "Rated",
    blockBtn: "Block Applicant",
    unBlockBtn: "Unblock Applicant",
    blockModalConfirmMessage: "Are you sure you want to block this applicant?",
    unBlockModalConfirmMessage:
      "Are you sure you want to unblock this applicant?",
    pendingRequests: "Show Pending Requests",
    downloadProfiles: "Download Profiles",
    downloadProfile: "Download Profile",
    showEvents: "Show Events",
    applicantProfile: {
      labels: {
        basicInfo: {
          title: "Basic Info",
          enName: "Name (EN)",
          arName: "Name (AR)",
          firstName: "First Name (English)",
          middleName: "Middle Name (English)",
          lastName: "Family Name (English)",
          firstNameAr: "First Name (AR)",
          middleNameAr: "Middle Name (AR)",
          lastNameAr: "Family Name (AR)",
          countryCode: "Country Code",
          email: "Email",
          iqmaExpireDate: "Iqama Expire Date",
          stcNumber: "Stc Number",
          phoneNumber: "Phone Number",
          nationalId: "National Id",
          iqamaNumber: "Iqama Number",
          expiryDate: "Expiry Date",
          dateOfBirthHijri: "Date Of Birth(Hijri)",
          dateOfBirthGregorian: "Date Of Birth(Gregorian)",
          matlooobNumber: "Matlooob Number",
          role: "Role",
          gender: "Gender",
          age: "Age",
          height: "Height",
          weight: "Weight",
          disability: "Disability",
          diseases: "Diseases",
          chronicDisease: "Chronic disease",
          nationality: "Nationality",
          cityOfResidence: "City of Residence",
          autoDeduction: "Automatic Deduction",
          notifiable: "Notifiable",
        },
        educationInfo: {
          title: "Personal Information",
          education: "Education Level",
          filedsOfStudy: "Fields of Study",
          fieldOfStudyName: "Filed of Study Name",
        },
        languageInfo: {
          title: "Language Skills",
          language: "Language",
          proficiency: "Proficiency",
          addLanguage: "Add Language",
          removeLanguage: "Remove Language",
          proficiencyLevels: {
            beginner: "Beginner",
            elementary: "Elementary",
            intermediate: "Intermediate",
            advance: "Advanced",
            advanced: "Advanced",
            fluent: "Fluent",
            native: "Native",
          },
        },
        documentInfo: {
          title: "Documents",
          certificates: "Certificates",
          academicQualifications: "Academic Qualifications",
          cv: "CV",
          other: "Other",
        },
        bankInfo: {
          title: "Bank Information",
          bankName: "Bank Name",
          IBAN: "Iban Number",
          cardHolder: "Account Holder",
        },
      },
    },
  },
  applicantRequsets: {
    eventName: "Event Name",
    role: "Role",
    requestDate: "Request Date",
    actions: "Actions",
    accepted: "Accepted",
  },
  applicantEvents: {
    eventName: "Event Name",
    eventStatus: "Event Status",
    role: "Role",
    totalWorkingHours: "Total Working Hours",
    supervisorComments: "Supervisor Comments",
    rating: "Rating",
    notYetProvided: "Not Yet Provided",
    evaluationRounds: "Evaluation Rounds",
    round: "Round ",
    evaluationForm: "Evaluation Form",
  },
  search: "Search by event name",
  saveChanges: "Save Changes",
  applicantExportDetails: {
    applicantProfile: "applicants-profiles",
    basicInfo: "Basic Info",
    gender: "Gender",
    nationality: "Nationality",
    city: "City",
    iqamaNumber: "Iqama Number",
    phoneNumber: "Phone Number",
    id: "ID",
    education: "Education",
    educationLevel: "Education Level",
    filedsOfStudy: "Fields of Study",
    language: "Language",
    bankInfo: "Bank Info",
    bankName: "Bank Name",
    bankIban: "IBAN",
    bankCardHolder: "Card Holder Name",
    profile: "profile",
  },
  placeholders: {
    enterFirstName: "Enter first name",
    enterMiddleName: "Enter middle name",
    enterLastName: "Enter last name",
    enterFirstNameAr: "Enter first name in Arabic",
    enterMiddleNameAr: "Enter middle name in Arabic",
    enterLastNameAr: "Enter last name in Arabic",
    selectNationality: "Select nationality",
    selectCity: "Select city",
    enterCountryCode: "Enter country code",
    enterPhoneNumber: "Enter phone number",
    enterMatloobNumber: "Enter Matloob number",
    selectRole: "Select role",
    selectGender: "Select gender",
    enterNationalId: "Enter national ID",
    enterHeight: "Enter height",
    enterWeight: "Enter weight",
    enterIqamaNumber: "Enter Iqama number",
    selectMedicalCondition: "Select medical condition",
    selectDisability: "Select disability",
    selectBank: "Select bank",
    enterIban: "Enter IBAN",
    enterCardHolderName: "Enter card holder name",
    selectFieldOfStudy: "Select field of study",
    enterFieldOfStudy: "Enter field of study",
    enterStcNumber: "Enter STC number",
    selectLanguage: "Select language",
    selectProficiency: "Select proficiency",
    selectIqamaExpiryDate: "Select Iqama expiry date",
    selectDateOfBirthPlaceholder: "Select your date of birth",
    selectCompanyWorkedWith: "Select company",
    nationalIdExpireDatePlaceholder: "National ID Expire Date",
  },
  loyalApplicants: {
    pageTitle: "Loyal Applicants List",
    breadcrumb: "Loyal Applicants List",
    searchPlaceholder: "Search by Name/ID",
    columns: {
      id: "ID",
      name: "Name",
      nationality: "Nationality",
      role: "Role",
      rating: "Rating",
      tags: "Tags",
      addTag: "Add Tag",
    },
    filters: {
      allocation: "Allocation",
      nationality: "Nationality",
      role: "Role",
      tag: "Tag",
    },
    showingRange: "Showing {from}-{to} of {total} applicants",
    noDataDescription: "No loyal applicants found.",
    noDataSubDescription: "Applicants who meet the loyalty criteria will appear here automatically.",
    bulkActions: {
      selectedLabel: "{count} Selected",
      downloadProfile: "Download Profile",
      editTags: "Add/Edit Tag",
      deleteTags: "Delete Tags",
      remove: "Remove",
    },
    removeModal: {
      title: "Confirm Remove",
      messageSingle:
        "Are you sure you want to remove This applicant from loyal applicants list?",
      messageMultiple:
        "Are you sure you want to remove {count} applicants from loyal applicants list?",
      confirm: "Confirm",
      cancel: "Cancel",
      successSingle: "1 users have been removed from the List successfully.",
      successMultiple:
        "{count} users have been removed from the List successfully.",
    },
  },
  companyApplicantProfile: {
    breadcrumbApplicants: "Applicants",
    profileTitle: "Applicant Profile",
    profileNotFound: "Profile not found",
    profileNotFoundDescription:
      "This applicant profile could not be loaded.",
    backToApplicants: "Back to applicants list",
    contactPerson: "Contact Person",
    identity: "Identity",
    dateOfBirth: "Date of Birth",
    physicalDetails: "Physical Details",
    residencyId: "Residency ID",
    companyWorkedWith: "Company Worked With",
    fieldLabels: {
      nameEn: "Name English",
      nameAr: "Arabic Name",
      nationality: "Nationality",
      age: "Age",
      email: "Email",
      phoneNumber: "Phone Number",
      nationalId: "National ID",
      stcNumber: "Stc. No.",
      gregorian: "Gregorian",
      hijri: "Hijri",
      weight: "Weight",
      height: "Height",
      iqamaNumber: "Iqama Number",
      iqamaExpiry: "Iqama Expiry",
      matloobNumber: "Matloob No.",
    },
    healthAccessibility: "Health & Accessibility",
    hasMedicalCondition: "Has Medical Condition / Disease",
    medicalConditionDetails: "Medical Condition Details",
    hasDisability: "Has Disability",
    disabilityDetails: "Disability Details",
    noneReported: "None reported",
    noMedicalCondition: "No Medical Condition / Disease",
    noDisability: "No Disability",
    expired: "Expired",
    iqamaExpired: "Iqama is expired",
    verified: "Verified",
    unverified: "Unverified",
    assigned: "Assigned",
    roleLabel: "Role",
    pendingRequests: "Pending Requests",
    attendance: "Attendance",
    workingHours: "Working Hours",
    profileCompleteness: "Profile Completeness",
    completeStatus: "Complete",
    completeLabel: "{percent}% Complete",
    fieldsMissing: "{count} fields missing",
    missingRequiredFields: "Missing required fields",
    missingOptionalFields: "Missing fields",
    notProvided: "Not provided",
    required: "required",
    documentAvailable: "Available",
    downloadDocument: "Download document",
    uploadDocument: "Upload document",
    documentUploadFailed: "Document upload failed. Please try again.",
    copyIban: "Copy IBAN",
    ibanCopied: "IBAN copied to clipboard",
    autoDeductionDescription:
      "Enable automatic payroll deductions for this applicant",
  },
};

export default applicants;
